export default __webpack_public_path__ + "static/cis-21b26efeadbe2d343d732d923f187b5d.png";